// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.staff-master-container {
    display: flex;
    padding: 20px;
    gap: 20px;
}

.form-panel {
    flex: 1 1;
    border: 1px solid #ccc;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.list-panel {
    flex: 2 1;
    border: 1px solid #ccc;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

form label {
    display: block;
    margin: 10px 0 5px;
}

form input, form textarea {
    width: 100%;
    padding: 8px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.radio-buttons {
    display: flex;
    gap: 15px;
    align-items: center;
    margin-bottom: 10px;
}

.radio-buttons label {
    display: flex;
    align-items: center;
    font-weight: bold;
    gap: 5px;
}

.radio-buttons input[type="radio"] {
    accent-color: #03C9D7; /* Match the button color */
    width: 16px;
    height: 16px;
    cursor: pointer;
}


.buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

table {
    width: 100%;
    border-collapse: collapse;
}

table th, table td {
    border: 1px solid #ccc;
    padding: 10px;
    text-align: left;
}

table th {
    background-color: #f4f4f4;
}

table tr:hover {
    background-color: #f9f9f9;
    cursor: pointer;
}

.checkbox-container {
    margin-bottom: 15px; /* Spacing consistent with other form elements */
}

.checkbox-container label {
    display: flex;
    align-items: center;
    gap: -1000px; /* Small gap between the checkbox and the text */
    font-weight: bold;
    cursor: pointer; /* Makes the whole label clickable */
}


form .form-control {
    margin-bottom: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/StaffMaster.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;IACP,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,SAAO;IACP,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,qBAAqB,EAAE,2BAA2B;IAClD,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB,EAAE,gDAAgD;AACzE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY,EAAE,gDAAgD;IAC9D,iBAAiB;IACjB,eAAe,EAAE,oCAAoC;AACzD;;;AAGA;IACI,mBAAmB;AACvB","sourcesContent":[".staff-master-container {\r\n    display: flex;\r\n    padding: 20px;\r\n    gap: 20px;\r\n}\r\n\r\n.form-panel {\r\n    flex: 1;\r\n    border: 1px solid #ccc;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.list-panel {\r\n    flex: 2;\r\n    border: 1px solid #ccc;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\nform label {\r\n    display: block;\r\n    margin: 10px 0 5px;\r\n}\r\n\r\nform input, form textarea {\r\n    width: 100%;\r\n    padding: 8px;\r\n    margin-bottom: 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n}\r\n\r\n.radio-buttons {\r\n    display: flex;\r\n    gap: 15px;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.radio-buttons label {\r\n    display: flex;\r\n    align-items: center;\r\n    font-weight: bold;\r\n    gap: 5px;\r\n}\r\n\r\n.radio-buttons input[type=\"radio\"] {\r\n    accent-color: #03C9D7; /* Match the button color */\r\n    width: 16px;\r\n    height: 16px;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n.buttons {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 10px;\r\n}\r\n\r\ntable {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\ntable th, table td {\r\n    border: 1px solid #ccc;\r\n    padding: 10px;\r\n    text-align: left;\r\n}\r\n\r\ntable th {\r\n    background-color: #f4f4f4;\r\n}\r\n\r\ntable tr:hover {\r\n    background-color: #f9f9f9;\r\n    cursor: pointer;\r\n}\r\n\r\n.checkbox-container {\r\n    margin-bottom: 15px; /* Spacing consistent with other form elements */\r\n}\r\n\r\n.checkbox-container label {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: -1000px; /* Small gap between the checkbox and the text */\r\n    font-weight: bold;\r\n    cursor: pointer; /* Makes the whole label clickable */\r\n}\r\n\r\n\r\nform .form-control {\r\n    margin-bottom: 15px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
